import React from 'react';
import { useOutletContext } from 'react-router-dom';
import {
    ContactProfile,
    JobSummary,
    JobsDashboard,
    userIsWelcomeCallCoach,
} from '@enrich/shared-lib';

// Without a user in the outlet context the role is unknown, so fall back to
// the restricted view.
const useIsWelcomeCallCoach = () => {
    const user = useOutletContext();
    return !user || userIsWelcomeCallCoach(user);
};
export const RoleAwareContactProfile = () => {
    if (!useIsWelcomeCallCoach()) return <ContactProfile />;
    return (
        <ContactProfile
            showAdminActions={false}
            showMatchActions
            showResumeActions
        />
    );
};

export const RoleAwareJobSummary = () => {
    if (!useIsWelcomeCallCoach()) return <JobSummary />;
    return <JobSummary showMatchActions readOnly />;
};

export const RoleAwareJobsDashboard = (props) => {
    if (!useIsWelcomeCallCoach()) return <JobsDashboard {...props} />;
    return (
        <JobsDashboard
            {...props}
            showCreateJobAction={false}
            showClosedJobsAction={false}
        />
    );
};
